module.exports = __webpack_public_path__ + "img/Polyjetclub.6d2d51bf.png";